import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import Swal from "sweetalert2";
import moment from "moment";

const PendingReceiptVouchers = () => {
  const navigate = useNavigate();
  const [vouchers, setVouchers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const centerCode = localStorage.getItem("code");
  const sewadarOf = localStorage.getItem("sewadarOf");

  useEffect(() => {
    const fetchPendingVouchers = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/pending-vouchers`, {
          params:{sewadarOf,role,centerCode :centerCode},
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data.success) {
          setVouchers(response.data.data);
        }
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Failed to fetch pending vouchers", "error");
      }
    };
  
    fetchPendingVouchers();
  }, [sewadarOf, role, token]);
  
  // Filter vouchers based on search text
  const filteredVouchers = vouchers.filter(
    (v) =>
      v.gsrsNo?.toLowerCase().includes(searchText.toLowerCase()) ||
      v.documentNo?.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="container mt-4">
      <h6>Pending Receipt Vouchers</h6>
      <table className="table table-bordered mt-1">
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>SR No</th>
            <th>Vehicle No</th>
            <th>Document No</th>
            <th>Document Date</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredVouchers.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center">
                No pending vouchers
              </td>
            </tr>
          ) : (
            filteredVouchers.map((voucher, index) => (
              <tr key={voucher.id}>
                <td>{index + 1}</td>
                <td>{voucher.gsrsNo}</td>
                <td>{voucher.vehicleNo}</td>
                <td>{voucher.documentNo}</td>
                <td>
                  {voucher.documentDate
                    ? moment(voucher.documentDate).format("DD-MMM-YYYY")
                    : ""}
                </td>
                <td>{voucher.receiptStatus}</td>
                <td>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() =>
                      navigate("../../ApproveReceiptVoucher", {
                        state: { data: voucher },
                        replace: false,
                      })
                    }
                  >
                    Preview
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PendingReceiptVouchers;
